import conf from '../config/common';
import {showGlobalMessage} from '../app/modules/_common/actions/globalMessage/showGlobalMessage';
import {messages as M} from '../_metronic/i18n/messages';

export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const {
        auth: {accessToken}
      } = store.getState();

      if (accessToken) {
        config.headers.accessToken = `${accessToken}`;
      }

      config.baseURL = process.env.NODE_ENV === 'production' ? conf.base_URL : conf.dev_base_URL;

      return config;
    },
    error => {
      Promise.reject(error);
    }
  );
  axios.interceptors.response.use(
    response => {
      const {errorCode} = response.data;
      const isGeneralError = errorCode !== 0;
      const isInWhitelist = checkUrlIsInWhitelist(response);
      if (isGeneralError && !isInWhitelist) {
        showGlobalMessage(M[errorCode])(store.dispatch);
      }
      return response;
    },
    error => {
      if (!axios.isCancel(error)) {
        const isAuthError = error.response.status >= 400;
        const isNotLogout = error.request.responseURL !== `${conf.base_URL}/logout`;
        if (isAuthError && isNotLogout) {
          window.location.href = '/logout';
        }
      }

      return Promise.reject(error);
    });

}

const checkUrlIsInWhitelist = response => {
  return urlWhiteList.indexOf(response.config.url) >= 0;
};

const urlWhiteList = [
  '/files/generate6101Close',
];


